import XmlFormatter from "@ext/markdown/core/edit/logic/Formatter/Formatters/typeFormats/XmlFormatter";
import type { NodeSerializerSpec } from "@ext/markdown/core/edit/logic/Prosemirror/to_markdown";
import { cellIsInline, rowIsPacked } from "@ext/markdown/elements/table/edit/logic/formatters/xml/packing";
import type { Node } from "@tiptap/pm/model";

const getCellAttrs = (node: Node) => ({
	colspan: node.attrs.colspan === 1 ? null : `${node.attrs.colspan}`,
	rowspan: node.attrs.rowspan === 1 ? null : `${node.attrs.rowspan}`,
	align: node.attrs.align,
	aggregation: node.attrs.aggregation,
	filter: node.attrs.filter,
	sort: node.attrs.sort,
});

const tableCellFormatter: NodeSerializerSpec = async (state, node, parent) => {
	const openTag = XmlFormatter.openTag("td", getCellAttrs(node));
	const closeTag = XmlFormatter.closeTag("td");

	if (cellIsInline(node)) {
		state.write(openTag);
		await state.renderInline(node.firstChild);
		state.write(closeTag);
		// In a packed row the next cell continues the same line; in an expanded one it takes its own.
		if (!rowIsPacked(parent)) state.closeBlock(node);
		return;
	}

	await state.wrapContainer(openTag, closeTag, node, async () => await state.renderContent(node));
};

export default tableCellFormatter;
